import { Separator } from '@vizit/atoms';
import { cx } from '@vizit/theme';
import * as React from 'react';
import { Heading, type HeadingProps, HeadingVariant } from '../heading';

interface HeadingWithSeparatorProps extends React.PropsWithChildren, HeadingProps {
  headingText?: string;
}

const HeadingWithSeparator = React.forwardRef<HTMLDivElement, HeadingWithSeparatorProps>((props, ref) => {
  const { className, children, variant = HeadingVariant.H4, headingText = 'Welcome to Vizit', ...other } = props;

  return (
    <div ref={ref} className={cx('flex flex-col gap-8', className)}>
      <Heading variant={variant} {...other}>
        {headingText}
      </Heading>
      <Separator />
      {children}
    </div>
  );
});

export { HeadingWithSeparator };
